<script setup lang="ts">
import IconsMagic from '../Icons/Magic/index.vue'
import Hotkeys from '../Icons/Hotkeys/index.vue'

import IntroduceColumn from './@components/IntroduceColumn/index.vue'
import DetailsRow from './@components/DetailsRow/index.vue'

const { colors } = useTheme()
</script>

<template>
  <section w-full :style="{ backgroundColor: colors.grayLighter }" rounded-35px pt="50px <md:60px" pb-80px pl-20px pr-20px>
    <div flex="~ row <md:col" justify-center items-center space-x="100px <md:0" w-full>
      <IntroduceColumn title="Enchant Prompts" text="Magic is your spellbook of AI solutions. Effortlessly create, bookmark and discover prompts with a mighty set of features.">
        <template #icon>
          <IconsMagic size="30" background-color="transparent" :color="colors.black" />
        </template>
      </IntroduceColumn>

      <IntroduceColumn title="Conjure Hotkeys" text="Customizable hotkeys allow you to trigger your prompts quickly through shortcuts. Each interaction is like a magical snap.">
        <template #icon>
          <Hotkeys size="20" />
        </template>
      </IntroduceColumn>

      <IntroduceColumn title="Explore Solutions" text="Explore Snack Prompt's vast prompt library right from Magic's UI. Keep your work flowing while discovering new solutions.">
        <template #icon>
          <IconLogo :size="20" color="black" />
        </template>
      </IntroduceColumn>
    </div>

    <div w-full flex="~ col" mt-100px space-y-100px>
      <DetailsRow lottie-url="/images/Magic/lotties/CreatePrompt.lottie" title="CRAFT MAGIC AI SOLUTIONS" btn-text="TRY IT NOW" text="Create and edit prompts magically with customizable placeholders directly from the plugin’s intuitive UI. Tailor each spell to your exact needs, according to your goals." />
      <DetailsRow lottie-url="/images/Magic/lotties/UsingPrompt.lottie" reverse-position title="ENLIGHTEN YOUR PROMPT SPELLBOOK" btn-text="INSTALL MAGIC" text="Keep your favorite prompts organized and easily accessible. Discover, curate and bookmark new prompts to enrich your library of solutions. All within Magic’s UI." />
      <DetailsRow lottie-url="/images/Magic/lotties/DiscoverPrompt.lottie" title="DISCOVER FROM THE SUPREME LIBRARY" btn-text="START NOW" text="Couldn’t craft the perfect enchantment? Discover thousands of solutions from the community prompt library on Snack Prompt. All without leaving Magic’s window." />
    </div>
  </section>
</template>
